import PhotoHeart from '../src/LikingPhotos/PhotoHeart';
export default PhotoHeart;
